export default __webpack_public_path__ + "static/media/course-list-header-bg.584388e5.png";